const config = {
	API_URL: import.meta.env.VITE_API_URL,
	LOCAL_API_URL: import.meta.env.VITE_LOCAL_API_URL,
	RECAPTCHA_SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
}

export default config
